/**
 * Parse html into nodes the browser does not act on.
 *
 * A template's children belong to a separate document, so nothing is fetched and no custom element
 * is upgraded - a detached `<div>` starts a request for every image in the html. They sit on
 * `.content`, not on the template itself.
 */
export const parseHtmlFragment = (html: string): DocumentFragment => {
  const holder = document.createElement('template');
  holder.innerHTML = html;
  return holder.content;
};
